module.exports = __webpack_public_path__ + "img/index-solutions-info-hover.ab424f0b.png";